import InternetImg from "public/network-services/icons/internet-dci.png";
import SocImg from "public/network-services/icons/noc-soc-helpdesk.png";
import MonitoringImg from "public/network-services/monitoring.svg";

export const ADVANTAGES_CONSTANTS = [
  {
    image: InternetImg,
    title: "Unified View Across Network Layers",
    text: "Correlate data from logs, flows, devices, and users to gain actionable insight beyond surface-level metrics.",
  },
  {
    image: SocImg,
    title: "​Intelligent Automation for Faster Response",
    text: "Trigger alerts, workflows, and remediation steps automatically—reducing reliance on manual intervention.",
  },
  {
    image: MonitoringImg,
    title: "Seamless Integration with Existing Tools",
    text: "Enhance your current IT stack with observability that plugs into SIEMs, CMDBs, and cloud-native environments.",
  },
];
